import React from 'react';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import MuxPlayer from '@mux/mux-player-react';
import Iconify from '@simplytech/simply.general.iconify';
import './styles.video.css';

export enum AspectRatio {
  IPHONE = '9/16',
  WIDE = '16/9',
  // not supported yet
  IPAD = '3/4',
  SQUARE = '1/1',
}

export enum Position {
  bottomRight = 'bottomRight',
  bottomLeft = 'bottomLeft',
}
export interface FloatingVideoProps {
  videoPlaybackId: string;
  aspectRatio?: AspectRatio;
  position?: Position;
  height?: number;
  gifFrame?: number;
  thumbFrame?: number;
}

function getPositionConfig(position?: Position) {
  switch (position) {
    case Position.bottomRight:
      return { transformOrigin: 'bottom right' };
    case Position.bottomLeft:
      return { transformOrigin: 'bottom left' };
    default:
      return { transformOrigin: 'bottom right' };
  }
}

export default function FloatingVideo({
  videoPlaybackId,
  aspectRatio = AspectRatio.IPHONE,
  position = Position.bottomRight,
  height = 250,
  gifFrame = 2,
  thumbFrame = 2,
}: FloatingVideoProps) {
  const [playVideo, setPlayVideo] = React.useState(false);
  const [hovering, setHovering] = React.useState(false);
  const [canPlay, setCanPlay] = React.useState(false);
  const [minimize, setMinimize] = React.useState(false);

  const hoverThumbnail = `https://image.mux.com/${videoPlaybackId}/animated.gif?start=${gifFrame}`; //https://image.mux.com/${videoPlaybackId}/thumbnail.png?width=400&height=200&fit_mode=preserve&time=35
  const minimizedThumbnail = `https://image.mux.com/${videoPlaybackId}/thumbnail.png?height=200&time=${thumbFrame}`; //https://image.mux.com/${videoPlaybackId}/thumbnail.png?width=400&height=200&fit_mode=preserve&time=35
  const positionConfig = getPositionConfig(position);
  return (
    <>
      <div
        style={{
          ...styles.wrapper,
          aspectRatio,
          transform: `scale(${hovering ? 1.5 : 1})`,
          height: height, //hovering ? height * 1.5 : height,
          transformOrigin: positionConfig.transformOrigin,
          display: minimize ? 'none' : 'inherit',
        }}
        role="button"
        onClick={() => setPlayVideo(true)}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
      >
        <div style={{ position: 'relative' }}>
          <img
            src={hoverThumbnail}
            alt="video thumbnail"
            style={{
              opacity: playVideo && canPlay ? 0 : 1,
              cursor: 'pointer',
              borderRadius: 8,
              aspectRatio,
              width: '100%',
              objectFit: 'cover',
              // width: "100%",
              verticalAlign: 'middle',
            }}
            loading="lazy"
          />
          {playVideo && (
            <MuxPlayer
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                opacity: playVideo && canPlay ? 1 : 0,
                // @ts-ignore
                '--media-object-fit': 'cover',
                '--media-background-color': 'transparent',
                '--controls': 'none',
                borderRadius: 8,
                // aspectRatio: '9/16',
                height: height,
                width: '100%',
              }}
              paused={minimize}
              onCanPlay={() => setCanPlay(true)}
              autoPlay
              className="mux-player"
              streamType="on-demand"
              playbackId={videoPlaybackId}
              // primaryColor
              // secondaryColor
            />
          )}
          {playVideo && !canPlay && (
            <div style={{ position: 'absolute', top: 12, left: 12 }}>
              <CircularProgress size={24} style={{ color: '#ffffff' }} />
            </div>
          )}
          {hovering && (
            <div style={{ position: 'absolute', top: 0, right: 0 }}>
              <Box>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setMinimize(true);
                  }}
                >
                  <Iconify icon="mingcute:minimize-fill" color="#fff" />
                </IconButton>
              </Box>
            </div>
          )}
        </div>
      </div>
      <div
        className={'minimizedPreview'}
        style={{ display: minimize ? 'block' : 'none' }}
        onClick={() => setMinimize(false)}
      >
        <img
          src={minimizedThumbnail}
          alt="video thumbnail"
          style={{
            width: aspectRatio === AspectRatio.IPHONE ? 60 : '100%',
            height: aspectRatio === AspectRatio.WIDE ? 60 : '100%',
            cursor: 'pointer',
            borderRadius: 8,
            aspectRatio,
            objectFit: 'cover',
          }}
          loading="lazy"
        />
      </div>
    </>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  wrapper: {
    position: 'relative',
    zIndex: 2,
    cursor: 'pointer',
    transition: 'all .375s',
    width: '100%',
  },
};
